import { useState, useEffect } from 'react';
const useUpdatePatientForm = (initialArray: any[], replacementObject: any): any[] => {
  const [array, setArray] = useState<any[]>(initialArray);

  useEffect(() => {
    if (replacementObject?.id) {
      setArray(prevArray => 
        prevArray.map(item => 
          item.id === replacementObject.id ? replacementObject : item
        )
      );
    }
  }, [replacementObject]);

  return array;
};

export default useUpdatePatientForm;
